import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom"
import classes from "./styles.module.css";
import { useParams } from "react-router-dom";
import APIConfig from "../../../../api/APIConfig";
import AuthService from "../../../../services/auth.service";
import ReactLoading from "react-loading";

import {
    Box,
    Center,
    Heading,
    Text,
    Button,
    VStack,
    StackDivider,
    HStack,
} from '@chakra-ui/react';

function KontakPribadiPeserta() {
    const [nomorhp, setNomorHp] = useState('');
    const [provinsi, setProvinsi] = useState('');
    const [kotkab, setKotKab] = useState('');
    const [kecamatan, setKecamatan] = useState('');

    const [currentUser, setCurrentUser] = useState([]);
    const [spinner, setSpinner] = useState(false);  

    useEffect(() => {
        const user = AuthService.getCurrentUser();
    
        if (user) {
            setCurrentUser(user);
        }
    }, [])

    const getPesertaById = async() => {
        setSpinner(true);
        const response = await APIConfig.get(`/v1/peserta/${id}`);
        const data = await response.data
        setNomorHp(data.nomorPonselPeserta);
        setProvinsi(data.provinsi);
        setKotKab(data.kota);
        setKecamatan(data.kecamatan);
        setSpinner(false);
    };

    const { id } = useParams();

    useEffect(() => {
        getPesertaById();
        
    }, []);

    if (spinner) {
        return (
            <Center py={12}>
                <VStack align='stretch' fontFamily={'Inter'} pb={20}>
                <div className="section">
                    <div className="article">
                        <ReactLoading type="spin" color="#6554C0" />
                    </div>
                </div>
                </VStack>
            </Center>
              
        )
    }


    return (
        <Center py={6}>
        <VStack align='stretch' fontFamily={'Inter'}>
            <Text
                pt={10}
                paddingBottom={10}
                color={'gray.700'}
                fontWeight={600}
                fontSize={'3xl'}>
                Profil
            </Text>
            <HStack color={'gray.500'} pb={3}>
                <Link to="/peserta/profile"> Profil </Link>
                <p> / </p>
                <Link to="/peserta/profile/kontak"> Kontak Pribadi </Link>
            </HStack>
            <Box
                m='10px'
                w='4xl'
                h="100%"
                border='1px'
                borderColor='gray.200'
                justifyContent='left'
                rounded={'2xl'}
                p={6}
                className={classes.box}
                overflow={'hidden'}>
                <VStack 
                divider={<StackDivider borderColor='gray.200' />}
                spacing={4}
                align='stretch'
                >
                    <Heading
                        fontSize={'xl'}
                        fontFamily={'Inter'}>
                        Kontak Pribadi
                    </Heading>
                    <div justifyContent='left' justifyItems='left'>
                        <h3 className={classes.h} >Email</h3>
                        <p className={classes.p}>{currentUser.emailUser}</p>
                    </div>

                    <div>
                        <h3 className={classes.h}>Nomor ponsel</h3>
                        <p className={classes.p}>{nomorhp}</p> 
                    </div>

                    <div>
                        <h3 className={classes.h}>Provinsi</h3>
                        <p className={classes.p}>{provinsi}</p>
                    </div>

                    <div>
                        <h3 className={classes.h}>Kota / Kabupaten</h3>
                        <p className={classes.p}>{kotkab}</p>
                    </div>

                    <div>
                        <h3 className={classes.h}>Kecamatan</h3>
                        <p className={classes.p}>{kecamatan}</p>
                    </div>

                </VStack>
                <Center pt={6}>
                    <Link to={`/peserta/profile/isi-kontak/${id}`}>
                        <Button p={6} w='100%' rounded={'xl'} colorScheme='purple' variant='solid'>
                        Edit Kontak Pribadi
                        </Button>
                    </Link>
                </Center>
            </Box>
        </VStack>
        </Center>
    );
}

export default KontakPribadiPeserta;